import { render, staticRenderFns } from "./ChakraInfoView.vue?vue&type=template&id=928c0e8e&scoped=true&"
import script from "./ChakraInfoView.vue?vue&type=script&lang=ts&"
export * from "./ChakraInfoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928c0e8e",
  null
  
)

export default component.exports